import notificationService from "@/services/notificationService";

export default {
  namespaced: true,
  state: {
    unreadCount: 0,
    notifications: [],
  },
  getters: {
    unreadCount: (state) => state.unreadCount,
    notifications: (state) => state.notifications,
  },
  mutations: {
    setUnreadCount(state, count) {
      state.unreadCount = count;
    },
    setNotifications(state, list) {
      state.notifications = list;
    },
    decrementUnread(state) {
      if (state.unreadCount > 0) state.unreadCount--;
    },
    resetUnread(state) {
      state.unreadCount = 0;
    },
  },
  actions: {
    async fetchUnreadCount({ commit }) {
      try {
        const res = await notificationService.getUnreadCount();
        commit("setUnreadCount", res.data?.count || 0);
      } catch {
        // silently fail
      }
    },
    async fetchNotifications({ commit }, params) {
      try {
        const res = await notificationService.list(params);
        commit("setNotifications", res.data?.data || []);
      } catch {
        // silently fail
      }
    },
    async markRead({ commit, dispatch }, id) {
      await notificationService.markRead(id);
      commit("decrementUnread");
      dispatch("fetchNotifications");
    },
    async markAllRead({ commit, dispatch }) {
      await notificationService.markAllRead();
      commit("resetUnread");
      dispatch("fetchNotifications");
    },
  },
};
